import {
  ContextMenu,
  ContextMenuItem,
  ContextMenuSub,
  ContextMenuSubContent,
  ContextMenuSubTrigger,
} from "@/components/ui";
import type { MatterTeam } from "@/lib/types";
import { copyToClipboard } from "@/lib/utils/copyToClipboard";
import { Clipboard, Copy } from "lucide-react";
import type { ReactNode } from "react";

type MatterTeamRowContextMenuProps = {
  canDelete: boolean;
  canEdit: boolean;
  onDelete: () => void;
  onEdit: () => void;
  team: MatterTeam;
  trigger: ReactNode;
};

export function MatterTeamRowContextMenu({
  canDelete,
  canEdit,
  onDelete,
  onEdit,
  team,
  trigger,
}: MatterTeamRowContextMenuProps) {
  return (
    <ContextMenu
      entityName="matter team"
      open={canEdit ? { onSelect: onEdit } : false}
      delete={canDelete ? { onSelect: onDelete } : false}
      trigger={trigger}
    >
      <ContextMenuSub>
        <ContextMenuSubTrigger>
          <Copy />
          Copy
        </ContextMenuSubTrigger>
        <ContextMenuSubContent>
          <ContextMenuItem
            onSelect={() => {
              void copyToClipboard(team.label, "Team label");
            }}
          >
            <Clipboard />
            Copy team label
          </ContextMenuItem>
          <ContextMenuItem
            disabled={!team.description}
            onSelect={() => {
              void copyToClipboard(team.description ?? "", "Description");
            }}
          >
            <Clipboard />
            Copy description
          </ContextMenuItem>
        </ContextMenuSubContent>
      </ContextMenuSub>
    </ContextMenu>
  );
}
